export function run(callback: () => void | Promise<void>): void {
    setTimeout(callback, 0)
}
